module.exports = __webpack_public_path__ + "img/logo-footer.545ac693.png";